// @flow

import Featureflow from 'featureflow-client';

import constants from './constants';

let featureflow = Featureflow.init(constants.FF_API_KEY, {}, {streaming: false});

export default featureflow;
